module.exports = "/images/gotham-3.jpg";